import { formatISO, parse, isValid } from 'date-fns';
import { formatDate, parseDate } from 'utilities';

export const INPUT_FORMAT = 'dd.MM.yyyy';

export const toISO = (d: Date | null): string | undefined => (d ? formatISO(d, { representation: 'date' }) : undefined);

export const toDate = (s: string | undefined): Date | null => (s ? (parseDate(s) ?? null) : null);

export const fmtInput = (d: Date | null): string => (d ? formatDate(toISO(d) as string) : '');

export const parseInput = (s: string): Date | null => {
  if (!s.trim()) {
    return null;
  }
  const d = parse(s.trim(), INPUT_FORMAT, new Date());
  return isValid(d) ? d : null;
};
